import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const OnzeAanpakPage = () => {
  const stappen = [
    {
      nummer: '01',
      titel: 'Herstel',
      beschrijving: 'Het hervinden van balans en vertrouwen',
      details: 'We beginnen met het creëren van een veilige omgeving waar jongeren hun zelfvertrouwen kunnen herwinnen. Door persoonlijke aandacht en begrip helpen we hen hun innerlijke kracht terug te vinden.',
      icon: 'ri-heart-line',
      kleur: 'purple'
    },
    {
      nummer: '02',
      titel: 'Groei',
      beschrijving: 'Het versterken van motivatie en vaardigheden',
      details: 'In deze fase werken we aan het ontwikkelen van praktische vaardigheden en het versterken van de motivatie. Jongeren leren hun talenten kennen en bouwen aan hun zelfbeeld.',
      icon: 'ri-plant-line',
      kleur: 'green'
    },
    {
      nummer: '03',
      titel: 'Toekomst',
      beschrijving: 'Het bouwen aan duurzame schooldeelname',
      details: 'Het laatste stadium richt zich op de terugkeer naar het onderwijs. We begeleiden jongeren bij het maken van concrete plannen en zorgen voor een soepele overgang naar school.',
      icon: 'ri-graduation-cap-line',
      kleur: 'blue'
    }
  ];

  const ervaringen = [
    {
      tekst: "Door HerStart heb ik geleerd dat ik meer kan dan ik dacht. Nu ga ik weer met plezier naar school.",
      naam: "Sarah, 16 jaar",
      locatie: "Amsterdam"
    },
    {
      tekst: "De begeleiders van HerStart hebben me geholpen om mijn angsten te overwinnen en weer vertrouwen te krijgen.",
      naam: "Mike, 15 jaar", 
      locatie: "Utrecht"
    },
    {
      tekst: "Ik dacht dat school niets voor mij was, maar HerStart heeft me laten zien dat iedereen kan leren.",
      naam: "Fatima, 17 jaar",
      locatie: "Rotterdam"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e3b2c8e5726a7a19ea27e3d6d49e6676.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/70 to-gray-900/50"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Onze Aanpak
            </h1>
            <p className="text-xl md:text-2xl text-gray-100 leading-relaxed">
              Een persoonlijke en bewezen methode die jongeren stap voor stap begeleidt 
              van thuiszitten naar een succesvolle terugkeer naar het onderwijs.
            </p>
          </div>
        </div>
      </section>

      {/* Onze Methode */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Een Bewezen Methode
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Onze aanpak is gebaseerd op jarenlange ervaring en wetenschappelijk onderzoek. 
              We combineren persoonlijke begeleiding met praktische vaardigheden om duurzame resultaten te bereiken.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Persoonlijke Begeleiding
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Individuele aandacht:</strong> Elke jongere krijgt een persoonlijk begeleidingsplan
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Veilige omgeving:</strong> We creëren een plek waar jongeren zich geaccepteerd voelen
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Flexibele aanpak:</strong> We passen ons aan het tempo en de behoeften van elke jongere aan
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Holistische benadering:</strong> We kijken naar de hele persoon, niet alleen naar schoolprestaties
                  </p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20counselor%20having%20a%20supportive%20conversation%20with%20a%20teenage%20student%20in%20a%20comfortable%20office%20setting%2C%20warm%20lighting%2C%20books%20and%20plants%20in%20background%2C%20empathetic%20and%20caring%20atmosphere%2C%20educational%20counseling%20session&width=600&height=400&seq=herstart-begeleiding&orientation=landscape"
                alt="Persoonlijke begeleiding bij HerStart"
                className="rounded-lg shadow-lg object-cover w-full h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Drie Stappen */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Drie Stappen naar Succes
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Onze bewezen methode bestaat uit drie duidelijke fasen die jongeren 
              stap voor stap begeleiden naar een succesvolle terugkeer naar het onderwijs.
            </p>
          </div>

          <div className="space-y-12">
            {stappen.map((stap, index) => (
              <div key={index} className={`flex flex-col lg:flex-row items-center gap-8 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className="flex-1">
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 rounded-full bg-${stap.kleur}-100 flex items-center justify-center mr-4`}>
                      <i className={`${stap.icon} text-${stap.kleur}-600 text-xl`}></i>
                    </div>
                    <div>
                      <span className={`text-sm font-semibold text-${stap.kleur}-600 uppercase tracking-wider`}>
                        Stap {stap.nummer}
                      </span>
                      <h3 className="text-2xl font-bold text-gray-900">
                        {stap.titel}
                      </h3>
                    </div>
                  </div>
                  <p className="text-lg text-gray-600 mb-4">
                    {stap.beschrijving}
                  </p>
                  <p className="text-gray-700">
                    {stap.details}
                  </p>
                </div>
                <div className="flex-1">
                  <img 
                    src={`https://readdy.ai/api/search-image?query=Young%20students%20in%20educational%20setting%20showing%20$%7Bstap.titel.toLowerCase%28%29%7D%2C%20positive%20learning%20environment%2C%20diverse%20group%20of%20teenagers%2C%20bright%20classroom%20with%20natural%20light%2C%20hope%20and%20growth%2C%20educational%20materials%20and%20books%20visible&width=600&height=400&seq=herstart-stap-${index + 1}&orientation=landscape`}
                    alt={`Stap ${stap.nummer}: ${stap.titel}`}
                    className="rounded-lg shadow-lg object-cover w-full h-80"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ervaringen */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Ervaringen van Jongeren
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Lees wat jongeren zelf zeggen over hun ervaring met HerStart en 
              hoe onze begeleiding hen heeft geholpen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {ervaringen.map((ervaring, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 shadow-sm">
                <div className="mb-4">
                  <i className="ri-double-quotes-l text-orange-500 text-2xl"></i>
                </div>
                <p className="text-gray-700 mb-6 italic">
                  "{ervaring.tekst}"
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-user-line text-orange-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{ervaring.naam}</p>
                    <p className="text-sm text-gray-600">{ervaring.locatie}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-orange-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Klaar voor een Nieuwe Start?
          </h2>
          <p className="text-xl text-orange-100 mb-8 max-w-3xl mx-auto">
            Onze ervaren begeleiders staan klaar om jou of je kind te helpen 
            bij de terugkeer naar het onderwijs. Neem vandaag nog contact op.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button href="/contact?onderwerp=hulp" variant="secondary" size="lg">
              Neem Contact Op
            </Button>
            <Button href="/trainingen" variant="outline" size="lg" className="bg-white text-orange-500 border-white hover:bg-orange-50">
              Bekijk Onze Trainingen
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OnzeAanpakPage;
